import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { LOCALE_ID } from '@angular/core';
import { AppModule } from './app/app.module';
import localesEs from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

registerLocaleData(localesEs, 'es-CL');


platformBrowserDynamic().bootstrapModule(AppModule, {
    providers: [{provide: LOCALE_ID, useValue: 'es-CL' }]
  })
  .catch(err => console.error(err));


